import {
    Route,
    Routes,
} from 'react-router-dom';

import {PricingConfigProvider} from "@flexinet/pricing-components";
import {IndexPage} from './pages/IndexPage';
import {authenticatedPricingConfig} from "../../config/pricing.ts";

// Single-page module today: application-products is one page. It uses the
// module/* layout shape for consistency with the other modules (FNP-1119).
//
// No RBAC gate here, unlike the other module layouts. The rbacActions enum has
// no action covering application products — the service-plan actions that would
// have applied were removed in FNP-1116 because no deployed AVP schema declares
// them. Gating is designed in FNP-1122; adding a check against a non-existent
// action here would fail closed and hide the page entirely.
//
// PricingConfigProvider stays wrapped around the page: IndexPage and the
// pricing-components hooks below it read the authenticated config from context.
export const ApplicationProductsLayout = () => {

    return (
        <PricingConfigProvider config={authenticatedPricingConfig}>
            <Routes>
                <Route
                    path='/'
                    element={<IndexPage/>}
                />
            </Routes>
        </PricingConfigProvider>
    );
};
